export default "__VITE_ASSET__K91XxNtu__"